import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";

import { permissionMiddleware } from "~/lib/permission-middleware";
import type { ReferralRewardRow } from "~/lib/server/referral-rewards";

export type { ReferralRewardRow };

// ============================================================================
// Query Keys
// ============================================================================

export const referralRewardQueryKeys = {
  all: ["referral-rewards"] as const,
};

// ============================================================================
// Server Functions
// ============================================================================

/**
 * Admin audit/manual-review listing of every referral reward (R18). Thin
 * wrapper: auth middleware + delegation to `listReferralRewards` in
 * `~/lib/server/referral-rewards` (the testable business logic).
 */
export const getReferralRewardsFn = createServerFn({ method: "POST" })
  .middleware([permissionMiddleware("coaches:read")])
  .handler(async (): Promise<ReferralRewardRow[]> => {
    const { getDBWithInit } = await import("~/lib/db");
    const { listReferralRewards } =
      await import("~/lib/server/referral-rewards");

    const db = await getDBWithInit();
    return listReferralRewards(db);
  });

export const referralRewardsQueryOptions = queryOptions({
  queryKey: referralRewardQueryKeys.all,
  queryFn: () => getReferralRewardsFn(),
});
